<template>
  <v-card flat class="bg-pwt_snow">
    <AvatarRow v-if="!loading" class="my-5" />
    <!-- loading animation -->
    <v-row no-gutters align="center" v-else class="my-5">
      <v-skeleton-loader type="avatar" class="mr-3" color="background" />
      <v-skeleton-loader type="text, text" width="30%" color="background" />
      <v-spacer />
    </v-row>
  </v-card>
</template>

<script setup lang="ts">
import { useUserStore } from "@/domains/user/userStore.ts";
import { computed } from "vue";
import AvatarRow from "./AvatarRow.vue";

const userStore = useUserStore();
const loading = computed(() => userStore.usersIsFetching)
</script>
